import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiariesFetchFailedAction = {
	type: 'BENEFICIARIES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiariesFetchFailedAction => ({
	type: 'BENEFICIARIES_FETCH_FAILED',
	payload,
});
